var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7991 13H8.10491V8.09171C8.10491 6.20646 9.59969 4.64018 11.467 4.62113C13.3532 4.60209 14.8951 6.14933 14.8951 8.04886V8.81058C14.8951 9.44376 15.3996 9.95316 16.0268 9.95316H17.5357C18.1629 9.95316 18.6674 9.44376 18.6674 8.81058V8.04886C18.6674 4.04985 15.4374 0.798265 11.4764 0.812547C7.51549 0.826829 4.33259 4.12126 4.33259 8.12027V13H3.20089C1.95131 13 0.9375 14.0236 0.9375 15.2852V22.9023C0.9375 24.1639 1.95131 25.1875 3.20089 25.1875H19.7991C21.0487 25.1875 22.0625 24.1639 22.0625 22.9023V15.2852C22.0625 14.0236 21.0487 13 19.7991 13Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.990d1bc2.svg";
export { ForwardRef as ReactComponent };